import { ComponentVariantFromApiModel } from '@models/api-models/component-variant-fromapi';
import { ComponentBindingModel } from '@models/component-binding';
import { ComponentDependencyModel } from '@models/component-dependency';
import { ComponentVariantModel } from '@models/component-variant';
import { ComponentVariantChangeModel } from '@models/component-variant-change';
import { VariantColorFromApiModel } from '@models/variant-color-from-api';
import { BindingConstants } from '@shared/dependency-constants';
import { MenuConstants } from '@shared/menu-constants';
import { IDependencyCalculator } from "../dependency-calculator.interface";

export class FindNewChangeByColorDependencyCalculator implements IDependencyCalculator {

	constructor(
		private getChooseableVariant: (componentUuid: string, variantUuid: string, variantSizeUuid?: string) => Promise<Array<ComponentVariantFromApiModel> | undefined>
	) {
	}

	async getChanges(
		dependency: ComponentDependencyModel,
		bindings: Array<ComponentBindingModel>,
		variant: ComponentVariantModel,
		oppositChosenVariants: Array<ComponentVariantModel>,
		variantSelectionToCheckAgainst: Array<ComponentVariantModel>,
		lastBindings: Array<ComponentBindingModel>
	): Promise<Array<ComponentVariantChangeModel>> {
		const b = bindings.filter(x => x.ComponentId === variant.Component.Id && x.VariantColor);

		if (!b.length) {
			return [];
		}

		console.debug(`Finding new change by color for variant: ${variant.Code}`);

		const possibleVariants = await this.getChooseableVariant(variant.Component.Uuid, variant.Uuid, variant.VariantSize?.Uuid);

		const allColors = possibleVariants?.[0].VariantSizes[0].VariantColors;

		let colorResult: VariantColorFromApiModel | undefined;

		if (dependency.Binding === BindingConstants.Block) {
			const colors = allColors?.filter(x => x.ColorUuid !== variant.VariantColor?.ColorUuid);
			colorResult = colors?.find(x => x.Default) ?? colors?.[0];
		}
		else if (dependency.Binding === BindingConstants.PermitOnly) {
			colorResult = allColors?.find(x => b.some(t => t.VariantColor?.ColorUuid === x.ColorUuid));
		}

		//probably shouldn't even get this far but for some reason it happens on RIM when dealing with the dependency that forces WG nosepads on platinum anything else
		//i.e. if you change from platinum to WG it will give a warning that nosepads will be turned from WG to WG (similar if you change to platinum while nosepad is WG)
		//hence this check
		//there isn't the same issue on HORN for the dependency forcing WG nosepads on BG temple and I don't know why :-( /INR
		if(colorResult?.Color?.Id === variant.VariantColor?.Color?.Id) {
			return [];
		}

		const res = Object.assign(new ComponentVariantModel(variant.Discontinued, variant.New), variant);
		res.NotSelected = false;
		const result = new ComponentVariantChangeModel(variant, res, null);
		if (result.NewComponentVariant)
			result.NewComponentVariant.VariantColor = colorResult;
		result.MenuTypesWithWarning.push(MenuConstants.COLOR);

		return [result];
	}

}
